import { isArray } from "utils";

const arrayIncludes = (arr, toFind) => {
  return isArray(arr) ? arr.includes(toFind) : false;
};

export default arrayIncludes;
